import { DailyForecastReportRequestModel } from '../api/models/DailyForecastReportRequestModel';
import { DailyForecastReportFormModel } from '../models';

export const dataFormToRequest = (
  data: DailyForecastReportFormModel
): DailyForecastReportRequestModel => {
  return {
    from: data.from,
    to: data.to,
    currency_id: data?.with_revenue && data.currency ? Number(data.currency.id) : null,
    fixed_at: data?.with_revenue && data?.fixed_at ? Number(data?.fixed_at) : null,
    rate_ids: (data?.rates || []).map(item => Number(item)),
    room_type_ids: data?.roomTypeIds,
    card_id: data?.company?.id,
    gross_revenue: data?.with_revenue ? data?.gross_revenue : false,
    with_revenue: data?.with_revenue,
    currency_application: data?.with_revenue ? data?.currency_application : null,
    file_type: data?.file_type,
  };
};
